export default __webpack_public_path__ + "static/media/search-icon.5cb27e75.svg";